<template>
  <div class="dashboardActionHeading p-0 mb-5">
    <div class="container py-5">
      <div class="row justify-content-center align-items-center">
        <div class="col-12 col-md-11 col-lg-11 col-xl-11">
          <breadcrumb v-if="isBreadcrumbVisible" />
          <div v-if="(steps && !steps.isHide) || $route.name === 'issueContract'">
            <h5 class="d-flex py-0 my-0"><b>إصدار عقد
                إلكترونيا</b>
            </h5>
            <div class="d-flex justify-content-between align-center">
              <ul class="dashboardActionHeading__steps page-title-tools float-right d-sm-contents"
                v-if="steps && !steps.isHide">
                <li class="d-sm-none d-md-block">
                  <span class="steps" :class="steps.firstPartnerStep.stepClass">
                    {{ steps.firstPartnerStep.order }}
                  </span>
                  <span class="steps-text" :class="steps.firstPartnerStep.stepClass">
                    <b>
                      {{ steps.firstPartnerStep.title }}
                    </b>
                  </span>
                </li>
                <li class="d-sm-none d-md-block">
                  <span class="steps" :class="steps.contractDurationStep.stepClass">
                    {{ steps.contractDurationStep.order }}
                  </span>
                  <span class="steps-text" :class="steps.contractDurationStep.stepClass">
                    <b>
                      {{ steps.contractDurationStep.title }}
                    </b>
                  </span>
                </li>
                <li class="d-sm-none d-md-block">
                  <span class="steps" :class="steps.contractDataStep.stepClass">
                    {{ steps.contractDataStep.order }}
                  </span>
                  <span class="steps-text" :class="steps.contractDataStep.stepClass">
                    <b>
                      {{ steps.contractDataStep.title }}
                    </b>
                  </span>
                </li>
                <li class="d-sm-none d-md-block">
                  <span class="steps" :class="steps.reviewStep.stepClass">
                    {{ steps.reviewStep.order }}
                  </span>
                  <span class="steps-text" :class="steps.reviewStep.stepClass">
                    <b>
                      {{ steps.reviewStep.title }}
                    </b>
                  </span>
                </li>
              </ul>
              <span class="d-flex align-items-center text-primary d-none d-sm-block d-md-none">
                <b> خطوة 1 من 5 </b>
              </span>
            </div>
          </div>
          <div
            v-if="$route.name && ['contractDetails', 'requestDetails', 'contractVerificationResult'].includes($route.name)">
            <ContractHeaderComponent :header="headerData" />
          </div>
          <!--<div class="d-flex justify-content-between" v-if="$route.name === 'userContracts'">
            <h5 class="py-3">العقود</h5>
            <button type="button" class="btn button--greenFill px-8" @click="onStartContractService">تقديم طلب توثيق
              عقد</button>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { moduleProxy } from '../../store';
import { ContractStatusEnum } from '@/enums/contract-status.enum';
import Breadcrumb from '@/components/Breadcrumb/breadcrumb';
import { Constants } from '@/utils/constants';
import ContractHeaderComponent from '../contract/contract-header.component.vue';

@Component({
  components: { Breadcrumb, ContractHeaderComponent },
})
export default class HeaderComponent extends Vue {
  contractStatusEnum = ContractStatusEnum;
  time = 0;

  onStartContractService(): void {
    window.location.href = `${window.location.origin}${Constants.CONTRACTS_NAJIZ_SERVICE_DESCRIPTION_PATH}`;
  }

  get headerData() {
    return moduleProxy.Header.getHeaderData;
  }

  get isBreadcrumbVisible() {
    return moduleProxy.BreadCrumb.isVisible;
  }

  get steps() {
    return moduleProxy.Stepper.getSteps;
  }
}
</script>
